/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Button, Typography, styled } from "@mui/material";

export const GuestTopRestaurantsCard = styled(Box)({
  border: '1px solid #d7dde8',
  borderRadius: '12px',
  backgroundColor: '#ffffff',
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
  padding: '18px 16px',
  minHeight: '100px',
  maxHeight: '331px',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  overflow: 'hidden',
});

export const GuestTopRestaurantsHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const GuestTopRestaurantsIconWrap = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#7c8ea5',
});

export const GuestTopRestaurantsTitle = styled(Typography)({
  fontSize: '12px',
  lineHeight: 1.2,
  fontWeight: 700,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: '#61748a',
});

export const GuestTopRestaurantsList = styled(Box)({
  display: 'grid',
  gap: '12px',
  gridAutoRows: 'max-content',
  alignContent: 'start',
  overflowY: 'auto',
  paddingRight: '4px',
  minHeight: 0,
  flex: 1,
});

export const GuestTopRestaurantsItem = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '28px minmax(0, 1fr)',
  gap: '10px',
  alignItems: 'start',
});

export const GuestTopRestaurantsItemIndex = styled(Box)({
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  backgroundColor: '#f1f5f9',
  color: '#5d7188',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '13px',
  fontWeight: 700,
});

export const GuestTopRestaurantsItemMeta = styled(Box)({
  minWidth: 0,
});

export const GuestTopRestaurantsItemName = styled(Typography)({
  fontSize: '15px',
  lineHeight: 1.25,
  fontWeight: 600,
  color: '#233044',
  marginBottom: '2px',
});

export const GuestTopRestaurantsItemAmount = styled(Typography)({
  fontSize: '12px',
  lineHeight: 1.35,
  fontWeight: 500,
  color: '#61748a',
});

export const GuestTopRestaurantsLoadingWrap = styled(Box)({
  display: 'grid',
  gap: '10px',
});

export const GuestTopRestaurantsEmptyState = styled(Typography)({
  fontSize: '13px',
  lineHeight: 1.4,
  color: '#61748a',
  textAlign: 'center',
  margin: 'auto 0',
});

export const GuestTopRestaurantsErrorState = styled(Box)({
  display: 'grid',
  justifyItems: 'center',
  gap: '12px',
  fontSize: '13px',
  lineHeight: 1.4,
  color: '#61748a',
  textAlign: 'center',
  margin: 'auto 0',
});

export const GuestTopRestaurantsRetryButton = styled(Button)({
  minWidth: '96px',
  textTransform: 'none',
  borderColor: '#64748b',
  color: '#233044',
  fontWeight: 600,
  '&:hover': {
    borderColor: '#475569',
    backgroundColor: 'rgba(100, 116, 139, 0.06)',
  },
});
